<template>
    <div>
      <video id="v_video" :src="url" type="application/x-mpegURL" controls preload="auto"  width="100%" height="90%" :autoplay="autoplay" ref="video" data-setup="{}"></video>
    </div>
</template>

<script>
import videojs from "video.js";
import webmms from "webmms-client";
import { set as setCookie, get as getCookie, remove as removeCookie } from "es-cookie";
import conf from '@/config/config';

export default {
  name: 'Video',
  props: ['pageParams'],
  data() {
    return {
      url: '',
      autoplay: true,
      eiInfo: {
          eiName: '',
          eiTag: '',
          ddn : ''
      },
       webmmsOptions : {
            EiToken: '',
            SToken: '',
            UToken: ''
      },
      error: true,
      timeout: 0,
      mmsReady: false,
      mms: null
    };
  },
  async created() {
    this.readQueryParam();
    this.startMMS();
  },
  async beforeMount() {
     await this.subscribeMMS();
  },
  beforeDestroy() {
      this.removeEvent();
  },
  methods: {
    startMMS(){
          this.mms =  webmms({
            wsurl: conf.wsurl,
            EiToken: getCookie("video-EiToken") || "",
            SToken: getCookie("video-SToken") || ""
          });
      },
    readQueryParam(){
        let { url, autoplay, username, password } = this.pageParams;
        if(url)
          url = url.replace("watch?v=", "embed/");
        let auth;
        if(username){
          auth = btoa(`${username}:${password}`);
          console.log(auth);
        }
        this.autoplay = autoplay || true;
        setTimeout(()=>{
          this.loadVideo(url,auth);
        }, 2000)
        //let newUrl = URI(url).addSearch({output: "embed"});
        //this.url = url;
    },
    loadVideo (url, auth) {
      // this.$refs.video;
      // this.url = url;

        videojs.Hls.xhr.beforeRequest = function(options) {
          options.headers = options.headers || {};
          options.headers.Authorization = `Bearer ${auth}`;
          options.withCredentials = false;
          console.log('options', options)
          return options;
        };
      var player = videojs('v_video',{
         html5: {
                hls: {
                    withCredentials: false
                },
                vhs: {
                    withCredentials: false
                }
            },
      });
      console.log(url);
      player.src({
        src: url,
        type: 'application/x-mpegURL',
        withCredentials: false
      });
      // this.url = url;
      player.play();
      // player.ready(function() {
      //   this.src({
      //     src: url,
      //     type: 'application/x-mpegURL',
      //     withCredentials: false
      //   });
      // });
    },
    async subscribeMMS() {
        this.removeEvent = this.mms.on("registered", async reply => {
            //console.log('reply=%s', JSON.stringify(reply))
             if(reply.ErrMsg == "OK"){
                this.eiInfo.ddn = reply.result.DDN;
                this.webmmsOptions.EiToken = reply.result.EiToken;
                this.webmmsOptions.SToken = reply.result.SToken;
                this.webmmsOptions.UToken = reply.result.UToken;
                if(this.eiInfo.eiName == ''){
                  this.eiInfo.eiName = reply.result.EiName ? reply.result.EiName : 'pgVIDEO' + this.makeId(5);
                }
                 if(this.eiInfo.eiTag == ''){
                  this.eiInfo.eiTag = reply.result.EiTag ? reply.result.EiTag : '';
                }
             }

             let expiredTime = 60 * 60 * 24 * 30 * 12;

             setCookie("video-EiToken", this.webmmsOptions.EiToken);
             setCookie("video-SToken", this.webmmsOptions.SToken);


             console.log('regtoCenter: %s', reply.ErrMsg);
             this.mmsReady = true;
             this.error = false;
             let deviceInfo = {"DDN":this.eiInfo.ddn,"EiOwner":"","EiName":this.eiInfo.eiName,"EiType":".page","EiTag":this.eiInfo.eiTag,"EiLoc":""};
             let result = await this.mms.setDeviceInfo(deviceInfo);
             console.log('SetDevice reply=%s', JSON.stringify(result));
             await this.track(this.mms, 'video', this.pageParams);
        });

        this.mms.on('message', (method, from, data, retcb) => {
              this.mmsReady = true;
             this.error = false;
             console.log('rcve: from=%s, data=%s', from, JSON.stringify(data));
            if ( typeof retcb == 'function') retcb({"ErrCode":0, "ErrMsg":"OK"})
        });

        this.mms.on('state', msg => {
            console.log('WS error: %s', msg);
            this.mmsReady = false;
            this.error = true;
        });

        this.mms.on('disconnect', msg => {
            this.mmsReady = false;
            this.error = true;
        });

        this.mms.on('error', err => {
             this.mmsReady = false;
            this.error = true;
        });

        this.mms.on('connect_error', err => {
             this.mmsReady = false;
            this.error = true;
        });

        this.mms.on('connect_timeout', err => {
            this.mmsReady = false;
            this.error = true;
        });
      }

  }
};
</script>

<style lang="sass">
.Url
  +ab_start
  +size(100%, 100%)
  -webkit-overflow-scrolling: touch
  overflow-y: auto
  iframe
    z-index: 9999
</style>
